<template>
  <div>
    <baidu-map class="map_container" :center="center" :scroll-wheel-zoom="true" :zoom="zoom" ak="53oVIOgmSIejwV7EfphPgTynOZbIiVYu">
      <bm-scale anchor="BMAP_ANCHOR_TOP_RIGHT"></bm-scale>
      <!--缩放控件-->
      <bm-navigation anchor="BMAP_ANCHOR_BOTTOM_RIGHT"></bm-navigation>
      <bm-marker :position="center" :dragging="true" animation="BMAP_ANIMATION_BOUNCE">
        <bm-label :content="content" :labelStyle="{ fontSize : '24px'}" :offset="{width: -105, height: 30}" />
      </bm-marker>
    </baidu-map>
  </div>
</template>
<script>
import BaiduMap from 'vue-baidu-map/components/map/Map.vue';
import BmScale from 'vue-baidu-map/components/controls/Scale';
import BmNavigation from 'vue-baidu-map/components/controls/Navigation';
import BmMarkerClusterer from 'vue-baidu-map/components/extra/MarkerClusterer';
import BmMarker from 'vue-baidu-map/components/overlays/Marker';
import BmInfoWindow from 'vue-baidu-map/components/overlays/InfoWindow';
import BmLabel from 'vue-baidu-map/components/overlays/Label';
export default {
  data() {
    return {
      center: {
        lng: '112.584109',
        lat: '34.602059'
      },
      zoom: 16,
      content: '国家农机装备创新中心'
    };
  },
  components: {
    BaiduMap,
    BmScale,
    BmNavigation,
    BmMarkerClusterer,
    BmMarker,
    BmLabel,
    BmInfoWindow
  },
  methods: {
    handler({ BMap, map }) {
      this.center.lng = 116.404;
      this.center.lat = 39.915;
      this.zoom = 11;
      this.init('map', 11, 27, 30);
    }
  }
};
</script>
<style lang="stylus" scoped>
.map_container {
  width: 100%;
  height:378px;
  margin: 0 auto;
  border: 1px solid #DCDFE6;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
}
</style>



// WEBPACK FOOTER //
// src/pages/enViews/joinus/bMap.vue